import { ReactElement } from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import { AngleDownIcon } from 'components/Icons'

const CardContainer = styled.div`
  position: relative;
  border: 1px solid #e3e3e3;
  border-radius: 8px;
  padding: 16px;
  display: grid;
  align-items: center;
  grid-template-columns: min-content 1fr min-content;
  gap: 16px;
  cursor: pointer;

  :hover {
    border: 1px solid #d9d9d9;
  }
`

const OrphansCount = styled.div`
  width: 21px;
  min-width: 21px;
  height: 21px;
  background-color: #ffeaed;
  border-radius: 50%;
  color: #ff627b;
  font-size: 12px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
`

const CardTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #000000;
`

const StyledAngleDownIcon = styled(AngleDownIcon)`
  width: 10px;
  min-width: 10px;
  height: 10px;
  fill: #717171;
  transform: rotate(-90deg);
`

interface IOrphansLocationsCardProps {
  skippedLocationsCount: number
  setIsShowingOrphansLocationsList: (fn: (prevState: boolean) => boolean) => void
}

export const OrphansLocationsCard = ({
  skippedLocationsCount,
  setIsShowingOrphansLocationsList
}: IOrphansLocationsCardProps): ReactElement => {
  const toggleOrphansLocationsList = (): void => {
    setIsShowingOrphansLocationsList((prevState: boolean): boolean => !prevState)
  }

  return (
    <CardContainer onClick={toggleOrphansLocationsList}>
      <OrphansCount>{skippedLocationsCount}</OrphansCount>
      <CardTitle>
        <FormattedMessage id="routingProjectSidebar.orphansLocations.title" defaultMessage="Orphans stops" />
      </CardTitle>
      <StyledAngleDownIcon />
    </CardContainer>
  )
}
